import React from "react";
import { HeartHandshake, BookOpen, Users, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Гражданские споры",
  description: "Квалифицированная юридическая помощь в делах о наследстве, семейных и земельных спорах. Надежная защита ваших прав и интересов в судах общей юрисдикции.",
  icon: HeartHandshake,
  link: "/ServicesPage",
  action: "Подробнее об услуге",
  colorClass: "text-chart-1",
  bgClass: "bg-chart-1/10"
}, {
  title: "Арбитраж и бизнес",
  description: "Комплексное сопровождение коммерческой деятельности, представительство в арбитражных судах, взыскание задолженностей и правовой аудит договоров.",
  icon: Users,
  link: "/ServicesPage",
  action: "Для юридических лиц",
  colorClass: "text-chart-2",
  bgClass: "bg-chart-2/10"
}, {
  title: "Правовая аналитика",
  description: "Профессиональная экспертиза документов, оценка юридических рисков и разработка эффективных стратегий защиты в сложных правовых ситуациях.",
  icon: BookOpen,
  link: "/ServicesPage",
  action: "Заказать анализ",
  colorClass: "text-chart-3",
  bgClass: "bg-chart-3/10"
}];
export default function HowWeHelpYou() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="54093" id="направления-практики" ref={ref} className={cn("bg-background py-24 transition-opacity duration-700", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="container mx-auto px-4">
        <div className="mb-16 text-center max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-primary mb-4 font-serif">
            Направления практики
          </h2>
          <p className="text-lg text-secondary leading-relaxed font-sans">
            Адвокат Николай Кондрашов предоставляет высококвалифицированную юридическую поддержку, 
            основанную на 11-летнем опыте и глубоком понимании права.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, i) => <Card key={i} data-index={i} className="group relative border-border/80 bg-card hover:bg-card/80 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl overflow-hidden rounded-lg">
              <CardHeader className="p-10 pb-4">
                <div className={cn("w-14 h-14 rounded-md flex items-center justify-center mb-6 transition-transform duration-500 group-hover:scale-110 shadow-sm", service.bgClass, service.colorClass)}>
                  <service.icon className="w-7 h-7" strokeWidth={1.25} />
                </div>
                <CardTitle className="text-2xl font-bold text-primary mb-2 font-serif">
                  {service.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="px-10 pb-8">
                <CardDescription className="text-base leading-relaxed text-secondary font-sans">
                  {service.description}
                </CardDescription>
              </CardContent>
              <CardFooter className="px-10 pb-10 pt-0 mt-auto">
                <Button asChild variant="secondary" className="w-full justify-between border-border hover:bg-primary hover:text-primary-foreground transition-all duration-300 font-sans tracking-wide">
                  <Link to={service.link}>
                    {service.action}
                    <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" />
                  </Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}